var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "json-editor",
      class: { "json-editor--error": _vm.hasError || !!_vm.jsonError },
    },
    [
      _vm.label || _vm.placeholders.length
        ? _c(
            "div",
            { staticClass: "json-editor__toolbar" },
            [
              _vm.label
                ? _c("div", { staticClass: "json-editor__label" }, [
                    _vm._v(_vm._s(_vm.label)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "json-editor__prettify",
                  attrs: {
                    "x-small": "",
                    text: "",
                    color: "primary",
                    disabled: !_vm.canPrettify,
                  },
                  on: { click: _vm.prettify },
                },
                [
                  _c("v-icon", { attrs: { "x-small": "", left: "" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.csvTemplate
                          ? "mdi-format-align-left"
                          : "mdi-code-json"
                      )
                    ),
                  ]),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("campaign_factory.form.json_editor.prettify")
                      ) +
                      "\n    "
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.enableFormatToggle
        ? _c(
            "div",
            { staticClass: "json-editor__format" },
            [
              _c("span", { staticClass: "json-editor__chips-caption" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "campaign_factory.form.json_editor.body_format_label"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-btn-toggle",
                {
                  attrs: {
                    value: _vm.bodyFormat,
                    dense: "",
                    mandatory: "",
                    color: "primary",
                  },
                  on: { change: _vm.setBodyFormat },
                },
                [
                  _c("v-btn", { attrs: { "x-small": "", value: "json" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "campaign_factory.form.json_editor.body_format_json"
                          )
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    { attrs: { "x-small": "", value: "urlencoded" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "campaign_factory.form.json_editor.body_format_urlencoded"
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showHeaderSuggestions
        ? _c(
            "div",
            { staticClass: "json-editor__chips" },
            [
              _c("span", { staticClass: "json-editor__chips-caption" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "campaign_factory.form.json_editor.header_suggestions_label"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.commonHeaders, function (headerLine) {
                return _c(
                  "v-chip",
                  {
                    key: headerLine,
                    staticClass: "ma-1",
                    attrs: { "x-small": "", outlined: "", color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.insertHeaderLine(headerLine)
                      },
                    },
                  },
                  [_vm._v(_vm._s(headerLine))]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.placeholders.length || _vm.showConsentFunction
        ? _c(
            "div",
            { staticClass: "json-editor__chips" },
            [
              _c("span", { staticClass: "json-editor__chips-caption" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "campaign_factory.form.json_editor.placeholders_label"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.visibleChips, function (code) {
                return _c(
                  "v-tooltip",
                  {
                    key: code,
                    attrs: { top: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-chip",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ma-1",
                                      attrs: {
                                        "x-small": "",
                                        outlined: "",
                                        color: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.insertSnippet(
                                            "{{ " + code + " }}"
                                          )
                                        },
                                      },
                                    },
                                    "v-chip",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_vm._v(_vm._s(code))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.exampleFor(code)))]),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.secondaryPlaceholders.length
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { top: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "ma-1",
                                        attrs: { icon: "", "x-small": "" },
                                        on: {
                                          click: function ($event) {
                                            _vm.showAll = !_vm.showAll
                                          },
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("v-icon", { attrs: { "x-small": "" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.showAll ? "mdi-minus" : "mdi-plus"
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1746550442
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.showAll
                              ? _vm.$t(
                                  "campaign_factory.form.json_editor.show_less"
                                )
                              : _vm.$t(
                                  "campaign_factory.form.json_editor.show_more",
                                  {
                                    count: _vm.secondaryPlaceholders.length,
                                  }
                                )
                          )
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showConsentFunction
                ? _c(
                    "v-tooltip",
                    {
                      attrs: { top: "", "max-width": "420" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function (ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "v-chip",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass: "ma-1",
                                        attrs: {
                                          "x-small": "",
                                          outlined: "",
                                          color: "secondary",
                                          "data-cy": "chip-has-consent",
                                        },
                                        on: {
                                          click: _vm.insertConsentFunction,
                                        },
                                      },
                                      "v-chip",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { "x-small": "", left: "" } },
                                      [_vm._v("mdi-function-variant")]
                                    ),
                                    _vm._v("has_consent()"),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1785153379
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "campaign_factory.form.json_editor.has_consent_tooltip"
                            )
                          )
                        ),
                        _c("br"),
                        _c("code", [
                          _vm._v(_vm._s(_vm.consentFunctionExample)),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showConsentFunction
                ? _vm._l(_vm.consentStateFunctions, function (consentFunction) {
                    return _c(
                      "v-tooltip",
                      {
                        key: consentFunction.name,
                        attrs: { top: "", "max-width": "420" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "v-chip",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "ma-1",
                                          attrs: {
                                            "x-small": "",
                                            outlined: "",
                                            color: "secondary",
                                            "data-cy":
                                              "chip-" + consentFunction.name,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.insertSnippet(
                                                consentFunction.snippet
                                              )
                                            },
                                          },
                                        },
                                        "v-chip",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { "x-small": "", left: "" } },
                                        [_vm._v("mdi-function-variant")]
                                      ),
                                      _vm._v(
                                        _vm._s(consentFunction.name) + "()"
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "campaign_factory.form.json_editor." +
                                  consentFunction.name +
                                  "_tooltip"
                              )
                            )
                          ),
                          _c("br"),
                          _c("code", [_vm._v(_vm._s(consentFunction.snippet))]),
                        ]),
                      ]
                    )
                  })
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.effectiveValidateJson
        ? _c(
            "div",
            { staticClass: "json-editor__actions" },
            [
              _c("span", { staticClass: "json-editor__chips-caption" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("campaign_factory.form.json_editor.actions_label")
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "v-tooltip",
                {
                  attrs: { top: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "ma-1",
                                    attrs: {
                                      "x-small": "",
                                      outlined: "",
                                      color: "primary",
                                    },
                                    on: { click: _vm.insertEmptyPair },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { "x-small": "", left: "" } },
                                  [_vm._v("mdi-plus")]
                                ),
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.$t(
                                        "campaign_factory.form.json_editor.action_empty_pair"
                                      )
                                    ) +
                                    "\n        "
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1384768751
                  ),
                },
                [
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "campaign_factory.form.json_editor.action_empty_pair_tooltip"
                        )
                      )
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("codemirror", {
        ref: "cm",
        attrs: { value: _vm.innerValue, options: _vm.cmOptions },
        on: { input: _vm.onInput, blur: _vm.onBlur, ready: _vm.onCmReady },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: _vm.name, "data-vv-name": _vm.name },
        domProps: { value: _vm.innerValue },
      }),
      _vm._v(" "),
      _vm.hasError
        ? _c("div", { staticClass: "v-messages error--text" }, [
            _c("div", { staticClass: "v-messages__message" }, [
              _vm._v(_vm._s(_vm.firstError)),
            ]),
          ])
        : _vm.jsonError
        ? _c("div", { staticClass: "v-messages error--text" }, [
            _c("div", { staticClass: "v-messages__message" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("campaign_factory.form.json_editor.invalid_json", {
                      line: _vm.jsonError.line,
                      message: _vm.jsonError.message,
                    })
                  ) +
                  "\n    "
              ),
            ]),
          ])
        : _vm.hint
        ? _c("div", { staticClass: "v-messages theme--light" }, [
            _c("div", { staticClass: "v-messages__message" }, [
              _vm._v(_vm._s(_vm.hint)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.unknownPlaceholders.length
        ? _c("div", { staticClass: "v-messages json-editor__warnings" }, [
            _c("div", { staticClass: "v-messages__message" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "campaign_factory.form.json_editor.unknown_placeholders",
                      {
                        placeholders: _vm.unknownPlaceholders.join(", "),
                      }
                    )
                  ) +
                  "\n    "
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }